
import styled from 'styled-components';

export const WrapperLink = styled.div`
    display: flex;
    align-items: center;
    a {
      text-decoration: none;
      text-decoration-color: unset;
      margin-left: 2px;
    }
`;
